module.exports = __webpack_public_path__ + "img/Pferd_9O1A8526.84bdfc4f.jpg";